import styled from "styled-components";

export const ZoneAreaEditorStyled = styled.div`
  .zone_pick {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
  }
  .zone_chip {
    min-width: 44px;
    padding: 4px 10px;
    border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    border-radius: 16px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    cursor: pointer;
    &.active {
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
  }
  .map_box {
    position: relative;
    max-width: 720px;
    user-select: none;
    touch-action: none;
    &.drawable {
      cursor: crosshair;
    }
    img {
      display: block;
      width: 100%;
      pointer-events: none;
    }
  }
  .area {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    background: rgba(75, 30, 120, 0.18);
    pointer-events: none;
    span {
      padding: 0 4px;
      border-radius: 4px;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
    &.drawing {
      border-style: dashed;
    }
  }
  .area_list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }
  .area_item {
    display: flex;
    align-items: center;
    column-gap: 4px;
    padding: 2px 8px;
    border-radius: 6px;
    background: ${({ theme }) => theme.COLORS.GRAY_13};
  }
`;
